export enum UserCurvesSummaryTag {
  main = 'main',
  engieForecast = 'engie_forecast',
  engieForecastLongTerm = 'engie_forecast_lt',
  offtakeInjection = 'offtake_injection',
  networkAllocation = 'network_allocation',
  forecastOfftake = 'forecast_offtake',
  forecastInjection = 'forecast_injection',
}
